/**
 * @generated SignedSource<<97768cccac93d741518b5f035f001ed8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type memberBadgeFragment$data = {
  readonly bgColor: string;
  readonly text: string;
  readonly textColor: string;
  readonly " $fragmentType": "memberBadgeFragment";
};
export type memberBadgeFragment$key = {
  readonly " $data"?: memberBadgeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"memberBadgeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "memberBadgeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bgColor",
      "storageKey": null
    }
  ],
  "type": "Badge",
  "abstractKey": null
};

(node as any).hash = "92c26cca8fd0c7ec6f162a39541fc255";

export default node;
